import { baseTheme } from './SwitchBaseTheme.css';

/*******************
 * Component Theme
 *******************/

const SwitchRedwoodTheme = {
  baseTheme
};

/*******************
 * Exports
 *******************/

export { SwitchRedwoodTheme };
